import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/font.css'
import './utils/pxtorem.js'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$toast = Toast;
Vue.use(Vant);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
